<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading && pricing" style="position: relative">
        <v-container class="grey lighten-5">
          <v-row no-gutters class="pagination-table-header">
            <v-col
              cols="12"
              class="py-md-0"
            >
              <v-card
                class="pa-1 px-2"
                style="position: relative"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="cyan white--text"
                  >
                    <div class="white--text">
                      <v-icon
                        class="mr-2 white--text"
                      >
                        mdi-map-marker
                      </v-icon>
                      {{ lang($store, 'sap/listings.global.filter.hints.region') }}: {{ pricing.region_formatted }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      type="number"
                      v-model="pricing.sub_per_hour_price"
                      prepend-icon="mdi-cash-100"
                      :label="lang($store, 'sap/listings.global.filter.premises.per_hour')"
                      autocomplete="off"
                      :error-messages="(errors && errors.sub_per_hour_price)?errors.sub_per_hour_price:null"
                      @input="removeError('sub_per_hour_price')"
                      @change="updateRequest('sub_per_hour_price', $event)"
                      :loading="isRequestingNow.includes('sub_per_hour_price')"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      type="number"
                      v-model="pricing.additional_services_max"
                      prepend-icon="mdi-counter"
                      :label="$t('order_pricing.additional_services_max')"
                      autocomplete="off"
                      :error-messages="(errors && errors.additional_services_max)?errors.additional_services_max:null"
                      @input="removeError('additional_services_max')"
                      @change="updateRequest('additional_services_max', $event)"
                      :loading="isRequestingNow.includes('additional_services_max')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              v-if="pricing.items"
              class="pt-4"
            >
              <v-row>
                <v-col
                  v-for="(pricingItem, index) in pricing.items"
                  :key="pricingItem.id"
                  cols="12"
                  md="6"
                >
                  <v-card
                    class="pa-1 px-2"
                    style="position: relative"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        class="pt-4 text-center"
                      >
                        <premise-chip
                          :premises-type="
                            lang(
                              $store,
                              `sap/listings.global.filter.premises.${pricingItem.premises_type}`
                            )
                          "
                          color="cyan"
                          text-color="green"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="pricingItem.sub_base_price"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store,'sap/listings.global.filter.order_base_types.basic')
                            + ' (' + lang($store, 'sap/listings.global.filter.hints.additional_services')
                            + ': 0)'"
                          autocomplete="off"
                          :error-messages="(errors && errors['items'+index] && errors['items'+index]['sub_base_price'])
                            ?errors['items'+index]['sub_base_price']
                            :null"
                          @input="removeError('items'+index)"
                          @change="updateItemRequest(index,'sub_base_price', $event)"
                          :loading="isRequestingNow.includes(index + '.sub_base_price')"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="pricingItem.sub_complex_price"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store, 'sap/listings.global.filter.order_base_types.maintain')
                            + ' (' + lang($store, 'sap/listings.global.filter.hints.additional_services')
                            + ': 0)'"
                          autocomplete="off"
                          :error-messages="(errors && errors['items'+index] && errors['items'+index]['sub_complex_price'])
                            ?errors['items'+index]['sub_complex_price']
                            :null"
                          @input="removeError('items'+index)"
                          @change="updateItemRequest(index,'sub_complex_price', $event)"
                          :loading="isRequestingNow.includes(index + '.sub_complex_price')"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="pricingItem.sub_base_additions_price"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store, 'sap/listings.global.filter.order_base_types.basic')
                            + ' (' + lang($store, 'sap/listings.global.filter.hints.additional_services')
                            + ': ' + pricing.additional_services_max + ')'"
                          autocomplete="off"
                          :error-messages="(errors && errors['items'+index] && errors['items'+index]['sub_base_additions_price'])
                            ?errors['items'+index]['sub_base_additions_price']
                            :null"
                          @input="removeError('items'+index)"
                          @change="updateItemRequest(index,'sub_base_additions_price', $event)"
                          :loading="isRequestingNow.includes(index + '.sub_base_additions_price')"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="pricingItem.sub_complex_additions_price"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store, 'sap/listings.global.filter.order_base_types.maintain')
                            + ' (' + lang($store, 'sap/listings.global.filter.hints.additional_services')
                            + ': ' + pricing.additional_services_max + ')'"
                          autocomplete="off"
                          :error-messages="(errors && errors['items'+index] && errors['items'+index]['sub_complex_additions_price'])
                            ?errors['items'+index]['sub_complex_additions_price']
                            :null"
                          @input="removeError('items'+index)"
                          @change="updateItemRequest(index, 'sub_complex_additions_price', $event)"
                          :loading="isRequestingNow.includes(index + '.sub_complex_additions_price')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
/* constants */
import * as promises from "@/constants/promises";
import { ORDER_PRICING_CONTROL_USERS } from '~api/order_pricing_control_access';

/* utils */
import { prepareValidationMessages } from '@/utils';
import { router } from '@/plugins/vue-router';

/* proxies */
import OrderPricingProxy from '@/proxies/OrderPricing/OrderPricingProxy';
import OrderPricingItemProxy from '@/proxies/OrderPricing/OrderPricingItemProxy';

/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';

/* components */
import PremiseChip from '../../components/minialerts/PremiseChip.vue';

export default {
  name: 'ShowPricing',
  mixins: [
    updatePageContentMixin,
    validationMixin,
  ],
  components: {
    PremiseChip,
  },
  data() {
    return {
      pageLoading: false,
      isShowHistory: false,
      shouldSeeLoaderOnUpdating: true,
      isRequestingNow: [],
      pricing: null,
      errors: {},
    };
  },
  created() {
    if (!ORDER_PRICING_CONTROL_USERS.includes(this.account.phone)) {
      router.push({ name: 'home.default' });
      return;
    }

    this.pageLoading = true;
    this.fetchData();
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    premisesItems() {
      const items = [];
      Object.keys(promises)
        .forEach(key => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.premises.${promises[key]}`),
            value: promises[key],
          });
        });
      return items;
    },
  },
  watch: {
    '$route.params.pricingUuid': {
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    fetchData() {
      new OrderPricingProxy().find(this.$route.params.pricingUuid)
        .then((response) => {
          this.pricing = response.data.data.pricing;
        })
        .catch((error) => {
          console.error(error);
          return this.$router.push({
            name: 404,
          });
        })
        .finally(() => {
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    getUpdateSimpleRequestClient() {
      return new OrderPricingProxy();
    },
    updateRequest(property, val) {
      if (!this.pageLoading) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.pricing, property))(val)
          .catch((response) => {
            this.$nextTick(() => {
              if (response && response.data && 'data' in response.data) {
                this.errors = {
                  ...this.errors,
                  ...prepareValidationMessages(response.data.data),
                }
              }
            });
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    updateSimpleRequest(pricing, property) {
      return value => {
        const data = {};
        data[property] = value;
        return (new OrderPricingProxy()).update(pricing.uuid, data);
      };
    },
    updateItemRequest(index, property, val) {
      if (!this.pageLoading) {
        this.isRequestingNow.push(index + '.' + property);
        (this.updateSimpleItemRequest(this.pricing.items[index], property))(val)
          .catch((response) => {
            this.$nextTick(() => {
              if (response && response.data && 'data' in response.data) {
                this.errors = {
                  ...this.errors,
                  ['items' + index]: prepareValidationMessages(response.data.data),
                }
              }
            });
          })
          .finally(() => {
            const i = this.isRequestingNow.indexOf(index + '.' + property);
            if (i !== -1) this.isRequestingNow.splice(i, 1);
          });
      }
    },
    updateSimpleItemRequest(item, property) {
      return value => {
        const data = {};
        data[property] = value;
        return (new OrderPricingItemProxy()).update(item.id, data);
      };
    },
    getPremisesLabel(value) {
      const index = this.premisesItems.findIndex(n => n.value === value);
      return index > -1 ? this.premisesItems[index]['text'] : value;
      return value;
    },
  },
};
</script>

<style scoped lang="scss">


</style>
